module.exports = __webpack_public_path__ + "79e76e5e3adab7e626ff1c22fd3cec21.pdf";